export default "__VITE_ASSET__J_u5wGil__"